import {isDev} from "./config";
import {mockedParams} from "./params-mock";
import {IUser} from "../type/user";

interface IParams {
  csrfToken: string;
  connected_user: IUser;
}

export const getAppParams = (): IParams => ({
  csrfToken: getParam('csrfToken'),
  connected_user: getParam('connected_user')
});

const getParam = (name) => {
  return isDev ? mockedParams[name] : getPcParam(name);
};

const getPcParam = name => {
  return (window as any).pc ? (window as any).pc[name] : null;
};



// WEBPACK FOOTER //
// ./src/conf/params.ts